import Vue from 'vue';
import Router from 'vue-router';

import guestRoutes from './guest';
import userRoutes from './user';

import PageNotFound from '@/views/PageNotFound';

Vue.use(Router);

export default new Router({
  routes: [
    ...guestRoutes,
    ...userRoutes,
    { path: '*', component: PageNotFound },
  ],
});
